var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGift2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30.0 30.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,900 L0,900 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2842712,-1.52179594e-15 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 1.01453063e-15,23.2842712 0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i2",
    x1: "-3.54386655px",
    y1: "-6.55053257px",
    x2: "33.3091414px",
    y2: "33.6945921px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4054065,0 C13.536129,0 13.6421006,0.105971554 13.6421006,0.23669409 L13.6421006,7.91907418 C13.6406694,8.45309704 13.208045,8.88561573 12.6740218,8.88691632 L0.96807883,8.88691632 C0.434055636,8.88561573 0.00143116566,8.45309704 0,7.91907418 L0,0.23669409 C0,0.105971554 0.105971554,0 0.23669409,0 L13.4054065,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4",
    x1: "20.0978541px",
    y1: "-5.78568846px",
    x2: "-2.81256019px",
    y2: "10.4282625px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i5",
    x1: "6.8210503px",
    y1: "0px",
    x2: "6.8210503px",
    y2: "8.88691632px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB2D55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD3E36",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6953242,0 L12.6953242,7.445686 C12.6950635,7.71882637 12.4737738,7.94022196 12.2006336,7.94061334 L0.494927343,7.94061334 C0.221694688,7.94035238 0.000260967375,7.71891865 0,7.445686 L0,0 L12.6953242,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9659632,0 C16.2985822,0.00026085213 16.5681948,0.269767512 16.5685863,0.60238646 L16.5685863,2.43203178 C16.5679341,2.76446583 16.2983978,3.03368455 15.9659632,3.03394485 L0.602623154,3.03394485 C0.270188568,3.03368455 0.000652242457,2.76446583 0,2.43203178 L0,0.60238646 C0.000391521551,0.269767512 0.270004078,0.00026085213 0.602623154,0 L15.9659632,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i8",
    x1: "-3.90277403px",
    y1: "-2.96388711px",
    x2: "19.8155153px",
    y2: "4.33378021px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i9",
    x1: "8.28429316px",
    y1: "0px",
    x2: "8.28429316px",
    y2: "3.03394485px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB2D55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3C38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.492575,0 C15.5638572,0 15.62181,0.0577162266 15.62181,0.128998279 L15.62181,1.9586436 C15.62181,2.02992565 15.5638572,2.08764188 15.492575,2.08764188 L0.129234973,2.08764188 C0.0579528011,2.08764188 0,2.02992565 0,1.9586436 L0,0.128998279 C0,0.0577162266 0.0579528011,0 0.129234973,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93500672,0 C3.06572926,0 3.17170081,0.103987094 3.17170081,0.232261676 L3.17170081,8.48823522 C3.17170081,8.6165098 3.06572926,8.72049689 2.93500672,8.72049689 L0.23669409,8.72049689 C0.105971554,8.72049689 0,8.6165098 0,8.48823522 L0,0.232261676 C0,0.103987094 0.105971554,0 0.23669409,0 L2.93500672,0 Z M2.69831263,0.377248653 L0.473388181,0.377248653 L0.473388181,8.31738861 L2.69831263,8.31738861 L2.69831263,0.377248653 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i12",
    x1: "-0.840007636px",
    y1: "-2.50848528px",
    x2: "4.05239062px",
    y2: "10.6782623px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i13",
    x1: "1.58585041px",
    y1: "0px",
    x2: "1.58585041px",
    y2: "8.72049689px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09118017,0.102962853 L3.92187382,2.47621201 C4.05294475,2.58610167 4.07011556,2.78143883 3.96022589,2.91250977 C3.94858806,2.92639079 3.93575484,2.93922401 3.92187382,2.95086184 C3.83401712,3.02452076 3.72459737,3.05865836 3.61675365,3.05327465 C3.61309519,3.11422267 3.5894986,3.17631184 3.54591762,3.22829306 C3.53427979,3.24217408 3.52144657,3.25500731 3.50756555,3.26664513 L0.676871901,5.63989429 C0.513126603,5.77717809 0.27447847,5.77717809 0.110733172,5.63989429 C-0.0203377597,5.53000462 -0.0375085686,5.33466747 0.072381097,5.20359653 C0.084018924,5.18971551 0.0968521503,5.17688229 0.110733172,5.16524446 L2.94142682,2.7919953 C2.98214655,2.75785594 3.0274983,2.73220627 3.07517831,2.71504627 L0.525041441,0.577612684 C0.39397051,0.467723018 0.376799701,0.272385859 0.486689366,0.141314928 C0.498327193,0.127433906 0.51116042,0.11460068 0.525041441,0.102962853 C0.688786739,-0.0343209509 0.927434872,-0.0343209509 1.09118017,0.102962853 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i15",
    x1: "6.27649344px",
    y1: "-1.75925126px",
    x2: "-2.9800492px",
    y2: "10.3758354px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-332.0 -384.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 215.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.0 142.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.0 4.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.0 23.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2842712,-1.52179594e-15 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 1.01453063e-15,23.2842712 0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z",
    stroke: "url(#i2)",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.857142999999269 6.064814922601599)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.463242866559085 6.446498537312437)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 13.6421006,0 13.6421006,8.88691632 0,8.88691632 0,0",
    stroke: "none",
    fill: "url(#i4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.6740218,8.88691632 L0.96807883,8.88691632 C0.434055636,8.88561573 0.00143116566,8.45309704 0,7.91907418 L0,0.23669409 C0,0.105971554 0.105971554,0 0.23669409,0 L13.4054065,0 C13.536129,0 13.6421006,0.105971554 13.6421006,0.23669409 L13.6421006,7.91907418 C13.6406694,8.45309704 13.208045,8.88561573 12.6740218,8.88691632 Z",
    stroke: "url(#i5)",
    strokeWidth: 0.7,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.9366310472651094 6.919886718016641)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12.6953242,0 12.6953242,7.94061334 0,7.94061334 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 3.885941867876682)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16.5685863,0 16.5685863,3.03394485 0,3.03394485 0,0",
    stroke: "none",
    fill: "url(#i8)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.9659632,3.03394485 L0.602623154,3.03394485 C0.270188568,3.03368455 0.000652242457,2.76446583 0,2.43203178 L0,0.60238646 C0.000391521551,0.269767512 0.270004078,0.00026085213 0.602623154,0 L15.9659632,0 C16.2985822,0.00026085213 16.5681948,0.269767512 16.5685863,0.60238646 L16.5685863,2.43203178 C16.5679341,2.76446583 16.2983978,3.03368455 15.9659632,3.03394485 Z",
    stroke: "url(#i9)",
    strokeWidth: 0.7,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.4733881807060243 4.359330048582706)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15.62181,0 15.62181,2.08764188 0,2.08764188 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.698442756978693 6.542638064976928)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.17170081,0 3.17170081,8.72049689 0,8.72049689 0,0",
    stroke: "none",
    fill: "url(#i12)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.93500672,0 C3.06572926,0 3.17170081,0.103987094 3.17170081,0.232261676 L3.17170081,8.48823522 C3.17170081,8.6165098 3.06572926,8.72049689 2.93500672,8.72049689 L0.23669409,8.72049689 C0.105971554,8.72049689 0,8.6165098 0,8.48823522 L0,0.232261676 C0,0.103987094 0.105971554,0 0.23669409,0 L2.93500672,0 Z M2.69831263,0.377248653 L0.473388181,0.377248653 L0.473388181,8.31738861 L2.69831263,8.31738861 L2.69831263,0.377248653 Z",
    stroke: "url(#i13)",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.678041791683675 -3.552713678800501e-13) rotate(90.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i14)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-3.4440506e-13,-3.89571708e-12 4.03260699,-3.89571708e-12 4.03260699,5.74285714 -3.4440506e-13,5.74285714 -3.4440506e-13,-3.89571708e-12",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.09118017,0.102962853 L3.92187382,2.47621201 C4.05294475,2.58610167 4.07011556,2.78143883 3.96022589,2.91250977 C3.94858806,2.92639079 3.93575484,2.93922401 3.92187382,2.95086184 C3.83401712,3.02452076 3.72459737,3.05865836 3.61675365,3.05327465 C3.61309519,3.11422267 3.5894986,3.17631184 3.54591762,3.22829306 C3.53427979,3.24217408 3.52144657,3.25500731 3.50756555,3.26664513 L0.676871901,5.63989429 C0.513126603,5.77717809 0.27447847,5.77717809 0.110733172,5.63989429 C-0.0203377597,5.53000462 -0.0375085686,5.33466747 0.072381097,5.20359653 C0.084018924,5.18971551 0.0968521503,5.17688229 0.110733172,5.16524446 L2.94142682,2.7919953 C2.98214655,2.75785594 3.0274983,2.73220627 3.07517831,2.71504627 L0.525041441,0.577612684 C0.39397051,0.467723018 0.376799701,0.272385859 0.486689366,0.141314928 C0.498327193,0.127433906 0.51116042,0.11460068 0.525041441,0.102962853 C0.688786739,-0.0343209509 0.927434872,-0.0343209509 1.09118017,0.102962853 Z",
    stroke: "url(#i15)",
    strokeWidth: 0.9,
    fill: "none",
    strokeLinejoin: "round"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGift2);
export default __webpack_public_path__ + "static/media/icGift2.4c5e247d3b214aded28fcf7a20eb73e9.svg";
export { ForwardRef as ReactComponent };